import { useState } from 'react'
import { useAuth } from '../auth/AuthContext'
import { colors } from '../theme'

// Brand-prescribed hero treatment: Master Purple full-bleed background,
// white card centered. Eyebrow label at 10px / 700 / 3px tracking / uppercase.
export default function Login() {
  const { signInGoogle, loading, error } = useAuth()
  const [rememberMe, setRememberMe] = useState(true)

  return (
    <div
      style={{
        minHeight: '100vh',
        background: colors.purple,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        color: colors.white,
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 460,
          background: colors.white,
          color: colors.black,
          borderRadius: 18,
          padding: '40px 36px',
          boxShadow: '0 24px 64px rgba(35,31,32,0.18)',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 14,
            marginBottom: 28,
          }}
        >
          <img
            src="/parkify-logo.svg"
            alt="Parkify"
            style={{ height: 26, width: 'auto', display: 'block' }}
          />
          <span
            style={{
              fontSize: 12,
              fontWeight: 700,
              letterSpacing: '2.5px',
              color: colors.purple,
              textTransform: 'uppercase',
              borderLeft: `1px solid ${colors.divider}`,
              paddingLeft: 14,
              lineHeight: 1,
            }}
          >
            Sales
          </span>
        </div>

        <h1
          style={{
            fontSize: 28,
            fontWeight: 700,
            letterSpacing: '-0.5px',
            margin: '0 0 10px',
            color: colors.black,
          }}
        >
          Sign in to manage your proposals
        </h1>
        <p
          style={{
            fontSize: 14,
            color: colors.textMuted,
            lineHeight: 1.65,
            margin: '0 0 24px',
          }}
        >
          Restricted to <code style={{ color: colors.purple, fontWeight: 600 }}>@parkify.com</code>{' '}
          accounts. Paste demo notes and the portal builds a branded
          proposal you can send, edit, and track.
        </p>

        <button
          onClick={() => signInGoogle(rememberMe)}
          disabled={loading}
          style={{
            width: '100%',
            background: colors.purple,
            color: colors.white,
            border: 'none',
            borderRadius: 10,
            padding: '14px 16px',
            fontSize: 13,
            fontWeight: 700,
            letterSpacing: '1.2px',
            textTransform: 'uppercase',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10,
            opacity: loading ? 0.6 : 1,
            cursor: loading ? 'wait' : 'pointer',
          }}
        >
          <GoogleGlyph />
          {loading ? 'Signing in…' : 'Continue with Google'}
        </button>

        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            marginTop: 14,
            fontSize: 12,
            color: colors.textMuted,
            cursor: 'pointer',
          }}
        >
          <input
            type="checkbox"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
            style={{ accentColor: colors.purple }}
          />
          Keep me signed in for 7 days
        </label>

        {error ? (
          <div
            role="alert"
            style={{
              marginTop: 20,
              padding: '12px 14px',
              background: colors.warningBg,
              border: `1.5px solid ${colors.warningBorder}`,
              borderRadius: 10,
              color: colors.black,
              fontSize: 13,
              lineHeight: 1.55,
            }}
          >
            <span
              style={{
                color: colors.red,
                fontWeight: 700,
                marginRight: 4,
              }}
            >
              ⚠
            </span>
            {error}
          </div>
        ) : null}

        <div
          style={{
            marginTop: 28,
            paddingTop: 20,
            borderTop: `1px solid ${colors.divider}`,
            fontSize: 11,
            color: colors.textDim,
            lineHeight: 1.6,
          }}
        >
          Built on the same SSO as parkify-pay-ops. If your account already
          works for the Operator Dashboard, it works here.
        </div>
      </div>
    </div>
  )
}

function GoogleGlyph() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden>
      <path
        fill="#FFFFFF"
        d="M21.35 11.1H12v2.93h5.35c-.23 1.24-.94 2.29-2 3l3.23 2.5c1.88-1.74 2.97-4.3 2.97-7.35 0-.7-.07-1.39-.2-2.08z"
      />
      <path
        fill="#FFFFFF"
        opacity="0.85"
        d="M12 21c2.7 0 4.97-.89 6.62-2.42L15.4 16.1c-.9.6-2.04.96-3.4.96-2.61 0-4.83-1.76-5.62-4.13l-3.3 2.55C4.66 18.95 8.04 21 12 21z"
      />
      <path
        fill="#FFFFFF"
        opacity="0.7"
        d="M6.38 12.93c-.2-.6-.31-1.24-.31-1.93s.11-1.33.31-1.93L3.08 6.52C2.39 7.86 2 9.4 2 11s.39 3.14 1.08 4.48l3.3-2.55z"
      />
      <path
        fill="#FFFFFF"
        opacity="0.55"
        d="M12 5.43c1.47 0 2.79.51 3.83 1.5L18.7 4.06C16.97 2.45 14.7 1.5 12 1.5 8.04 1.5 4.66 3.55 3.08 6.52l3.3 2.55C7.17 7.19 9.39 5.43 12 5.43z"
      />
    </svg>
  )
}
